// boardCardFields.js — which schema fields may appear on board cards

import { normalizeSchemaFieldType } from 'utilities/FieldTypes';

/** Field types that do not render usefully on compact board cards. */
const BOARD_CARD_EXCLUDED_FIELD_TYPES = new Set([
  'checklist',
]);

/**
 * @param {unknown} fieldType
 * @returns {boolean}
 */
export function isBoardCardEligibleFieldType(fieldType) {
  const normalized = normalizeSchemaFieldType(fieldType, '');
  if (!normalized) return true;
  return !BOARD_CARD_EXCLUDED_FIELD_TYPES.has(normalized);
}

/**
 * @param {object|null|undefined} field
 * @returns {boolean}
 */
export function isBoardCardEligibleField(field) {
  if (!field || typeof field !== 'object') return false;
  const key = String(field.name || field.key || '').trim();
  if (!key) return false;
  return isBoardCardEligibleFieldType(field.type);
}

export { BOARD_CARD_EXCLUDED_FIELD_TYPES };
